import { Customer } from '../../dto/customer';

export class CustomerPopupInput {
  constructor(public customers: Customer[], public selected: Customer) {}
}
